/**
 * Get the status of a popup from local storage.
 *
 * Returns `true` if the popup has been dismissed.
 *
 * Returns `false` or `undefined` if the popup has not been dismissed
 */
export const getStatusFromStorage = ({
  storageKey,
  storageType,
}: {
  storageKey: string;
  storageType?: 'localStorage' | 'sessionStorage';
}): boolean | undefined => {
  if (
    typeof window !== 'undefined' &&
    typeof window[storageType ?? 'localStorage'] !== 'undefined'
  ) {
    const status = window[storageType ?? 'localStorage'].getItem(storageKey);

    if (status) {
      try {
        return JSON.parse(status) as boolean;
      } catch (error) {
        console.warn(
          `Failed to read from ${storageType ?? 'localStorage'}`,
          error
        );
      }
    }
  }

  return;
};
